import { render, staticRenderFns } from "./lp-label.vue?vue&type=template&id=8f6e94fa"
import script from "./lp-label.vue?vue&type=script&lang=js"
export * from "./lp-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports